module.exports = __webpack_public_path__ + "static/img/9.b641be1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/9.png
// module id = QCnj
// module chunks = 0